import { Container } from "react-bootstrap";
import ProjectCard from "./ProjectCards";
import Particle from "../Particle";
import editor from "../../Assets/Projects/codeEditor.png";
import chatify from "../../Assets/Projects/chatify.png";
import jsonorbit from "../../Assets/Projects/jsonorbit.png";

function Projects() {
  return (
    <Container fluid className="project-section">
      <Particle />
      <Container>
        <h1 className="project-heading" style={{ color: "white", marginBottom: "40px" }}>
          Open Source <strong className="purple">Contributions</strong>
        </h1>
        <p style={{ color: "white", fontSize: "1.2em", marginBottom: "50px", textAlign: "center" }}>
          Popular open source projects I've created and maintain
        </p>
        <div className="project-grid">
          <ProjectCard
            imgPath={jsonorbit}
            isBlog={false}
            title="JSON Orbit"
            description="The ultimate JSON viewer and TOON converter. Explore complex JSON structures, visualize data with graph-based mapping, and seamlessly convert between JSON and TOON formats for LLM prompts."
            ghLink="https://github.com/Sanjeet990/JSON-Orbit"
            webLink="https://jsonorbit.com/"
            demoLink="https://app.jsonorbit.com/"
          />
          <ProjectCard
            imgPath={editor}
            isBlog={false}
            title="Astroluma"
            description="A powerful and customizable home dashboard that simplifies your digital life. Built with React and Node.js, featuring real-time widgets, smart home integration, and extensive customization options. Over 700+ stars on GitHub."
            ghLink="https://github.com/Sanjeet990/Astroluma"
            webLink="https://www.reddit.com/r/Astroluma/"
          />
          <ProjectCard
            imgPath={chatify}
            isBlog={false}
            title="Apex Home Dashboard"
            description="A modern, customizable home dashboard solution built with the latest web technologies. Designed for smart home enthusiasts and those looking for a clean, efficient way to manage their digital life."
            ghLink="https://github.com/Sanjeet990/Apex-Home-Dashboard"
            webLink="https://www.reddit.com/r/selfhosted/comments/1h499u8/i_built_my_own_home_dashboard_after_trying_and/"
          />
        </div>
      </Container>
    </Container>
  );
}

export default Projects;
